import { Button, Card, Modal, Typography, Badge, Spin, Empty } from 'antd';
import {
  FileTextOutlined,
  PlusOutlined,
  ReloadOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import React, { useState, useEffect } from 'react';

import { getAttentionVoucherApi } from '../../../api/attentionVoucher';
import { getAccessTokenApi } from '../../../api/auth';
import AddAttentionVoucherForm from '../../../components/specialist/AttentionVoucher/AddAttentionVoucherForm/AddAttentionVoucherForm';
import Tables from '../../../Tables';
import { addKeyToArray } from '../../../utils/formaters';

function AttentionVoucher() {
  const [vouchers, setVouchers] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);

  const token = getAccessTokenApi();

  useEffect(() => {
    setLoading(true);
    getAttentionVoucherApi(token)
      .then((result) => {
        setVouchers(addKeyToArray(result.vouchers));
      })
      .catch((error) => {

      })
      .finally(() => {
        setLoading(false);
        setReload(false);
      });
  }, [token, reload]);

  // Calcular estadísticas
  const totalVouchers = vouchers.length;
  const todayVouchers = vouchers.filter((voucher) => {
    const today = new Date().toISOString().split('T')[0];
    return voucher.created_at?.split('T')[0] === today;
  }).length;

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header con estadísticas */}
        <Card className="shadow-sm border-0 bg-gradient-to-r from-blue-50 to-blue-100">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-3">
              <div className="bg-blue-600 p-2 rounded-lg">
                <FileTextOutlined className="text-white text-lg" />
              </div>
              <div>
                <Typography.Title level={3} className="mb-0 text-blue-800">
                  Comprobantes de Atención
                </Typography.Title>
                <Typography.Text type="secondary" className="text-blue-600">
                  Gestiona los comprobantes de atención realizados
                </Typography.Text>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-1">
                <CalendarOutlined className="text-green-600" />
                <Badge count={todayVouchers} size="small" />
                <span className="text-xs text-green-600">Hoy</span>
              </div>
              <div className="flex items-center space-x-1">
                <CheckCircleOutlined className="text-blue-600" />
                <Badge count={totalVouchers} size="small" />
                <span className="text-xs text-blue-600">Total</span>
              </div>
            </div>
          </div>
        </Card>

        {/* Botones de acción */}
        <Card className="shadow-sm border-0">
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              type="primary"
              size="large"
              icon={<PlusOutlined />}
              onClick={() => setModalVisible(true)}
              className="bg-blue-600 hover:bg-blue-700 border-blue-600 rounded-lg"
            >
              Generar Comprobante
            </Button>
            <Button
              size="large"
              icon={<ReloadOutlined />}
              onClick={() => setReload(true)}
              loading={loading}
              className="rounded-lg"
            >
              Actualizar
            </Button>
          </div>
        </Card>

        {/* Tabla de comprobantes */}
        <Card className="shadow-sm border-0">
          <div className="mb-4">
            <Typography.Title level={4} className="mb-0 text-gray-800">
              Lista de Comprobantes
            </Typography.Title>
            <Typography.Text type="secondary">
              {totalVouchers} comprobantes registrados
            </Typography.Text>
          </div>

          {loading ? (
            <div className="flex justify-center py-12">
              <Spin size="large" />
            </div>
          ) : vouchers.length === 0 ? (
            <Empty
              description="No hay comprobantes registrados"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            >
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setModalVisible(true)}
                className="bg-blue-600 hover:bg-blue-700 border-blue-600"
              >
                Crear Primer Comprobante
              </Button>
            </Empty>
          ) : (
            <Tables>
              <Tables.VoucherTable vouchers={vouchers} setReload={setReload} />
            </Tables>
          )}
        </Card>

        {/* Modal para crear comprobante */}
        <Modal
          title={
            <div className="flex items-center space-x-2">
              <FileTextOutlined className="text-blue-600" />
              <span>Crear Comprobante de Atención</span>
            </div>
          }
          footer={false}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          width="90%"
          style={{ maxWidth: '1200px' }}
          className="attention-voucher-modal"
        >
          <AddAttentionVoucherForm
            setReload={setReload}
            setModalVisible={setModalVisible}
          />
        </Modal>
      </div>
    </div>
  );
}

export default AttentionVoucher;
